import * as Yup from 'yup';

import { ISymbology } from '~/models/Symbology';

export const SymbologySchema: Yup.SchemaOf<
  Omit<ISymbology, 'id'>
> = Yup.object().shape({
  stimulus: Yup.string().required('Estímulo é necessário.'),
  symbology: Yup.string().required('Simbologia é necessária.'),
  application_in_method: Yup.string().required(
    'Aplicação do método é necessária.',
  ),
  example: Yup.string().required('Exemplo é necessário.'),
});
